import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Tooltip, Tag, DatePicker, Avatar, Button, Typography, Select, Divider, Row, Card } from 'antd';
import { DownloadOutlined, ExportOutlined, ImportOutlined, ReloadOutlined, UserOutlined } from '@ant-design/icons';
import PageTitle from '../../components/PageTitle';
import TableActionBar from '../../components/TableActionBar';
import _, { } from 'lodash';
import qs from 'qs';
import { Form } from '@ant-design/compatible';
import TextTruncate from 'react-text-truncate';
import CustomerServicesDetail from './CustomerServicesDetail';
import CustomerDetail from '../customers/CustomerDrawerDetail';
import { checkPermission } from '../../utils/permission';
import { cleanObject, stripHtml, makeTree, getFirstLetterOfWords, isValidDate, repeatPhoneNumber, CustomerServiceStatus, RenderCustomerServiceStatus } from '../../utils/helpers';
import HtmlParser from 'react-html-parser';
import NumberFormat from 'react-number-format';
import BaseSelect from '../../components/Elements/BaseSelect';
import moment from 'moment';
import HandlePhoneNumber from '../../components/HandlePhoneNumber';
import { getListServices, getSpecificService, getStatistical, exportExcel } from '../../redux/actions/CustomerServicesActions';
import { getSpecificCustomer } from '../../redux/actions/customerActions';
import { getCustomerSourceActive } from '../../redux/actions/CustomerSourceActions';
import StatisticNumber from '../../components/StatisticNumber';
import DynamicTable from '../../components/DynamicTable';
import FilterableMultiTreeSelect from '../../components/FilterableMultiTreeSelect';
import FilterableMultiSelect from '../../components/FilterableMultiSelect';
import { NotificationManager } from 'react-notifications';
import CustomAvatar from '../../components/CustomAvatar';
import PhoneNumberList from '../../components/PhoneNumberList';
import { getBranchActive } from '../../redux/actions/BranchActions';
import { getServiceActive } from '@/redux/actions/ServicesActions';
import html2canvas from 'html2canvas';
import CustomerInfoColumn from '@/components/customers/CustomerInfoColumn';

const { RangePicker } = DatePicker;
const routes = [
    {
        path: '/',
        breadcrumbName: 'Trang chủ',
    },
    {
        path: '/customer-services',
        breadcrumbName: 'Dịch vụ',
    },
]

const { Paragraph } = Typography;
const { Option } = Select;

class CustomerServicesList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            selectedRowKeys: [],
            isOpenDetail: false,
            currentData: null,
            isOpenCustomerDetail: false,
            currentCustomerData: null,
            loadingDetail: false,
            selectedValues: [],
            isLoadingExport: false,
            loadingCapture: false
        }
        this.tableRef = createRef();
    }

    componentDidMount() {
        var query = qs.parse(this.props.location.search.slice(1));
        this.setState({ isLoading: true });
        this.props.getListServices(query).then(() => {
            this.setState({ isLoading: false });
        })
        this.props.getCustomerSourceActive();
        this.props.getStatistical(query);
        this.props.getBranchActive();
        this.props.getServiceActive();

    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.location.search !== this.props.location.search.slice()) {
            var query = qs.parse(nextProps.location.search.slice(1));
            this.setState({ isLoading: true });
            this.props.getListServices(query).then(() => {
                this.setState({
                    isLoading: false
                })
            })
            this.props.getStatistical(query);
            this.setState({ selectedValues: [] })
        }
    }

    onChangeFilter(name, value) {
        var query = qs.parse(this.props.location.search.slice(1));
        query = {
            ...query,
            [name]: value
        }
        if (name === 'created_at') {
            if (value && value.length > 0) {
                query.created_date_start = moment(value[0]).format('YYYY-MM-DD');
                query.created_date_end = moment(value[1]).format('YYYY-MM-DD');
            } else {
                delete query.created_date_start;
                delete query.created_date_end;
            }
        }

        if (name === 'selected_at') {
            if (value && value.length > 0) {
                query.selected_date_start = moment(value[0]).format('YYYY-MM-DD');
                query.selected_date_end = moment(value[1]).format('YYYY-MM-DD');
            } else {
                delete query.selected_date_start;
                delete query.selected_date_end;
            }
        }

        if (name === 'customer_source_id') {
            if (value && value.length > 0) {
                let string = value.join(',');
                query.customer_source_id = string;
            } else {
                delete query.customer_source_id;
            }
        }

        delete query.created_at;
        delete query.selected_at;
        query = cleanObject(query);
        //console.log("query: ", query)
        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(query)
        });
    }

    onChangeTable(pagination, sorter) {
        var query = qs.parse(this.props.location.search.slice(1));
        if (!_.isEmpty(pagination)) {
            query = {
                ...query,
                page: pagination.current,
                per_page: pagination.pageSize,
            }
        }
        if (!_.isEmpty(sorter)) {
            if (sorter.order) {
                query = {
                    ...query,
                    sort_field: sorter.field,
                    sort_type: sorter.order === 'ascend' ? 'ASC' : 'DESC'
                }
            } else {
                delete query.sort_field;
                delete query.sort_type;
            }
        }

        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(query),
        });
    }

    toggleOpenDetail(isOpenDetail, data = null) {
        this.setState({ isOpenDetail: isOpenDetail, currentData: data });
    }

    onDetail(id) {
        this.setState({ current_id: id })
        this.props.getSpecificService(id).then(res => {
            this.toggleOpenDetail(true, res);
        })
    }

    toggleOpenCustomerDetail(isOpenCustomerDetail, data = null) {
        this.setState({ isOpenCustomerDetail: isOpenCustomerDetail, currentCustomerData: data });
    }

    onCustomerDetail(customer_id) {
        this.setState({ currentCustomerId: customer_id, loadingDetail: true })
        this.props.getSpecificCustomer(customer_id).then(res => {
            this.setState({ loadingDetail: false })
            this.toggleOpenCustomerDetail(true, res);
        })
    }

    reloadData() {
        var query = qs.parse(this.props.location.search.slice(1));
        this.setState({ isLoading: true });
        this.props.getListServices(query).then(() => {
            this.setState({ isLoading: false });
        });
        this.props.getStatistical(query);
    }

    handleSelectAll = () => {
        const { customer_source_active_list } = this.props;
        const allValues = customer_source_active_list.map(item => item.id);
        this.onChangeFilter('customer_source_id', allValues);
        this.setState({ selectedValues: allValues });
    }

    handleDeselect = (deselectedValue) => {
        const updatedValues = this.state.selectedValues.filter(value => value !== deselectedValue);
        this.setState({ selectedValues: updatedValues });
    }

    do_export() {
        var query = qs.parse(this.props.location.search.slice(1));
        this.setState({ isLoadingExport: true });
        this.props.exportExcel(query).catch(err => {
            this.setState({ isLoadingExport: false });
        });
        this.setState({ isLoadingExport: false });
        NotificationManager.success("Quá trình xuất file đang được thực hiện. Vui lòng kiểm tra email của bạn sau ít phút.", "Thông báo", 9000);
    }

    handleCaptureClick = async () => {
        this.setState({ loadingCapture: true });

        const table = this.tableRef.current;
        if (!table) return;

        // Tạo một bảng tạm thời với kích thước lớn
        const clonedTable = table.cloneNode(true);
        clonedTable.style.width = 'max-content';
        clonedTable.style.height = 'max-content';

        // Thêm bảng tạm thời vào body để tránh các ràng buộc CSS
        document.body.appendChild(clonedTable);

        // Chụp ảnh của bảng tạm thời
        await html2canvas(clonedTable).then(canvas => {
            // Chuyển canvas thành hình ảnh và tải xuống
            const imgData = canvas.toDataURL('image/jpg');
            const link = document.createElement('a');
            const d = new Date();
            const f = (n) => (`0${n}`).slice(-2);
            link.href = imgData;
            link.download = `dich-vu-${[f(d.getDate()), f(d.getMonth() + 1), d.getFullYear(), f(d.getHours()), f(d.getMinutes())].join('-')}.jpg`;
            link.click();

            // Loại bỏ bảng tạm thời sau khi đã chụp ảnh
            document.body.removeChild(clonedTable);
        });
        this.setState({ loadingCapture: false });
    };

    render() {
        var { services, pagination, users,
            service_active_list, customer_source_active_list, statistical, branchActiveList, doctors
        } = this.props;
        var { isLoading, selectedRowKeys,
            isOpenDetail,
            currentData, current_id,
            currentCustomerData,
            isOpenCustomerDetail,
            currentCustomerId,
            loadingDetail,
            isLoadingExport,
            loadingCapture
        } = this.state;
        const hasSelected = selectedRowKeys.length > 0;

        var query = qs.parse(this.props.location.search.slice(1));

        const columns = [
            // {
            //     title: 'Khách hàng',
            //     dataIndex: 'customer',
            //     key: 'customer',
            //     render: (text, record) => {
            //         if (checkPermission('customer', 'detail')) {
            //             return (
            //                 <>
            //                     <Link
            //                         to={`/customer/${record?.customer?.id}`}
            //                         className="color-primary item-action-btn"
            //                     >
            //                         <strong>{record?.customer?.full_name}</strong>
            //                     </Link>
            //                 </>
            //             )
            //         } else {
            //             return (
            //                 <>
            //                     <strong>{record?.customer?.full_name}</strong>
            //                 </>
            //             )
            //         }
            //     }
            //     // render: (text, record) => {
            //     //     if (checkPermission('customer', 'detail')) {
            //     //         return (
            //     //             <Tooltip title="Xem hồ sơ" placement="right">
            //     //                 <div className='color-primary item-action-btn' onClick={() => this.onCustomerDetail(record?.customer?.id)}>
            //     //                     <CustomAvatar name={record?.customer?.full_name} avatarUrl={record?.customer?.avatar} />
            //     //                     &nbsp;{record?.customer?.full_name}
            //     //                 </div>
            //     //             </Tooltip>
            //     //         )
            //     //     } else {
            //     //         return (
            //     //             <>
            //     //                 <CustomAvatar name={record?.customer?.full_name} avatarUrl={record?.customer?.avatar} />
            //     //                 &nbsp;{record?.customer?.full_name}
            //     //             </>
            //     //         )
            //     //     }
            //     // }
            // },
            // {
            //     title: 'Mã KH',
            //     dataIndex: 'customer_code',
            //     key: 'customer_code',
            //     width: '140px',
            //     sorter: true,
            //     render: (text, record) => {
            //         if (record?.customer) {
            //             return (
            //                 <Paragraph style={{ margin: 0 }} copyable={
            //                     {
            //                         text: record?.customer?.code || null,
            //                         tooltips: false
            //                     }
            //                 }>
            //                     {record?.customer?.code}
            //                 </Paragraph>
            //             )
            //         }
            //     }
            // },
            {
                title: 'Khách hàng',
                key: 'customer',
                width: 300,
                render: (_, record) => {
                    const customer = {
                        id: record?.customer?.id,
                        code: record?.customer?.code,
                        full_name: record?.customer?.full_name,
                        branch_name: record?.customer?.branche?.name,
                        conditions: record?.customer?.conditions,
                        customer_source: record?.customer?.customer_source?.name,
                        customer_status: record?.customer?.customer_status?.name,
                        customer_status_color: record?.customer?.customer_status?.text_color,
                        medical_book_number: record?.customer?.medical_book_number
                    }
                    return (
                        <CustomerInfoColumn
                            record={customer}
                            nameField="full_name"          // field tuỳ module
                            idField="id"
                            codeField="code"
                            branchField="branch_name"
                            //medicalBookField="medical_book_number"
                            //conditionField="conditions"
                            sourceField="customer_source"
                            statusField="customer_status"
                            statusColorField="customer_status_color"
                        />
                    )
                }
            },
            {
                title: 'Điện thoại',
                dataIndex: 'phone',
                width: '120px',
                key: 'phone',
                render: (text, record) => {
                    return (
                        <PhoneNumberList phones={record?.customer?.phones} />
                    )
                }
            },
            // {
            //     title: 'Trạng thái KH',
            //     dataIndex: 'customer_status',
            //     key: 'customer_status',
            //     width: '130px',
            //     render: (text, record) => {
            //         const status = record?.customer?.customer_status;
            //         return (
            //             <Tag color={status?.text_color}>
            //                 {status?.name}
            //             </Tag>
            //         );
            //     }

            // },
            {
                title: "Doanh số",
                dataIndex: "revenue",
                width: "120px",
                key: 'revenue',
                render: (text, record) => {
                    if (record?.customer?.revenue) {
                        return (
                            <NumberFormat value={record?.customer?.revenue || 0} displayType={'text'} thousandSeparator={true} />
                        )
                    }
                }
            },
            {
                title: "Công nợ",
                dataIndex: "customer_debt",
                width: "120px",
                key: 'customer_debt',
                render: (text, record) => {
                    if (record?.customer?.debt) {
                        return (
                            <NumberFormat value={record?.customer?.debt || 0} displayType={'text'} thousandSeparator={true} />
                        )
                    }
                }
            },
            {
                title: 'Tên dịch vụ',
                dataIndex: 'service_name',
                key: 'service_name',
                render: (text, record) => {
                    if (text) {
                        if (checkPermission('customer_services', 'detail')) {
                            return (
                                <Tooltip title="Xem chi tiết dịch vụ" placement="right">
                                    <div className='color-primary item-action-btn' onClick={() => this.onDetail(record.id)}>
                                        {text}
                                    </div>
                                </Tooltip>
                            )
                        } else {
                            return (
                                <>
                                    {text}
                                </>
                            )
                        }
                    } else {
                        return <Tag></Tag>
                    }
                }
            },
            {
                title: 'Ghi chú',
                dataIndex: 'note',
                key: 'note',
                width: '200px',
                render: (text, record) => {
                    return (
                        <div style={{ wordBreak: "break-word" }}>
                            <Tooltip title={HtmlParser(text)} placement="topLeft">
                                <TextTruncate line={1} truncateText="…" text={stripHtml(text)} />
                            </Tooltip>
                        </div>
                    )
                }
            },
            {
                title: "Giá gốc",
                dataIndex: "regular_price",
                width: "120px",
                key: 'regular_price',
                render: (text, record) => {
                    if (text) {
                        return (
                            <NumberFormat value={text} displayType={'text'} thousandSeparator={true} />
                        )
                    }
                }
            },
            {
                title: "Giá bán",
                dataIndex: "sale_price",
                width: "120px",
                key: 'sale_price',
                sorter: true,
                render: (text, record) => {
                    if (text) {
                        return (
                            <NumberFormat value={text} displayType={'text'} thousandSeparator={true} />
                        )
                    }
                }
            },
            {
                title: "Số lượng",
                dataIndex: "quantity",
                width: "100px",
                key: 'quantity',
                sorter: true,
                render: (text, record) => {
                    if (text) {
                        return (
                            <NumberFormat value={text} displayType={'text'} thousandSeparator={true} />
                        )
                    }
                }
            },
            {
                title: "Thành tiền",
                dataIndex: "amount",
                width: "120px",
                key: 'amount',
                sorter: true,
                render: (text, record) => {
                    if (text) {
                        return (
                            <NumberFormat value={text} displayType={'text'} thousandSeparator={true} />
                        )
                    }
                }
            },
            {
                title: 'Loại dịch vụ',
                dataIndex: 'type',
                key: 'type',
                render: (text, record) => {
                    if (record.type == 'QUANTAM') {
                        return (
                            <Tag color="#ffb406">Dịch vụ quan tâm</Tag>
                        )
                    } else if (record.type == 'CHOT') {
                        return (<Tag color='#03C03C'>Dịch vụ chốt</Tag>)
                    } else {
                        return (<>N/A</>)
                    }
                }
            },
            // {
            //     title: 'Nguồn',
            //     dataIndex: 'customer_source',
            //     key: 'customer_source',
            //     width: '130px',
            //     render: (text, record) => {
            //         return (<>{text}</>)
            //     }
            // },
            {
                title: 'Ngày chốt',
                dataIndex: 'selected_at',
                key: 'selected_at',
                width: '100px',
                render: (text, record) => {
                    if (text) {
                        return (
                            <div>{isValidDate(text, false)}</div>
                        )
                    }
                }
            },
            {
                title: 'Người chốt',
                dataIndex: 'staff_consultant',
                key: 'staff_consultant',
                width: '200px',
                render: (text, record) => {
                    if (text) {
                        return (
                            <div style={{ whiteSpace: 'pre-line' }}>
                                {text.replace(/, /g, ',\n')}
                            </div>
                        )
                    }
                }
            },
            {
                title: 'Bác sĩ',
                dataIndex: 'doctors',
                key: 'doctors',
                width: '200px',
                render: (text, record) => {
                    if (text) {
                        return (
                            <div style={{ whiteSpace: 'pre-line' }}>
                                {text.replace(/, /g, ',\n')}
                            </div>
                        )
                    }
                }
            },
            {
                title: 'Phụ tá',
                dataIndex: 'assistant_doctors',
                key: 'assistant_doctors',
                width: '200px',
                render: (text, record) => {
                    if (text) {
                        return (
                            <div style={{ whiteSpace: 'pre-line' }}>
                                {text.replace(/, /g, ',\n')}
                            </div>
                        )
                    }
                }
            },
            {
                title: 'Trạng thái',
                dataIndex: 'status',
                key: 'status',
                sorter: true,
                width: '100px',
                render: (text, record) => {
                    if (text) {
                        return (
                            <div>{RenderCustomerServiceStatus(text)}</div>
                        )
                    }
                }
            },
            {
                title: 'Ngày tạo',
                dataIndex: 'created_at',
                key: 'created_at',
                sorter: true,
                width: '140px',
                render: (text, record) => {
                    if (text) {
                        return (
                            <div>{isValidDate(text)}</div>
                        )
                    }
                }
            }
        ];

        return (
            <div>
                <PageTitle routes={routes} title="Dịch vụ" />
                <div>
                    <TableActionBar
                        isShowAddButton={false}
                        isShowDeleteButton={false}
                        showFilter={true}
                        onSearch={(value) => this.onChangeFilter('keyword', value)}
                        defaultKeyword={query.keyword}
                        activeFilter={
                            query.created_date_start ||
                            query.created_date_end ||
                            query.selected_date_start ||
                            query.selected_date_end ||
                            query.type ||
                            query.service_id ||
                            query.branch_id ||
                            query.customer_source_id ||
                            query.status ||
                            query.doctor_id ||
                            query.staff_id
                        }
                        placeholderSearch="Mã, tên, 3 số cuối sđt của khách hàng"
                        filters={
                            [
                                <BaseSelect
                                    options={doctors || []}
                                    optionValue="user_id"
                                    optionLabel="display_name"
                                    showSearch
                                    placeholder="Bác sĩ thực hiện"
                                    className="w-100"
                                    onChange={(value) => this.onChangeFilter('doctor_id', value)}
                                    defaultValue={query.doctor_id ? parseInt(query.doctor_id) : null}
                                />,
                                <BaseSelect
                                    options={users || []}
                                    optionValue="user_id"
                                    optionLabel="display_name"
                                    showSearch
                                    placeholder="Nhân viên chốt"
                                    className="w-100"
                                    onChange={(value) => this.onChangeFilter('staff_id', value)}
                                    defaultValue={query.staff_id ? parseInt(query.staff_id) : null}
                                />,
                                <FilterableMultiSelect
                                    options={branchActiveList || []}
                                    placeholder="Chọn cơ sở"
                                    parameterName='branch_id'
                                    optionValue="id"
                                    optionLabel="name"
                                />,
                                <RangePicker
                                    format="DD/MM/YYYY"
                                    placeholder={['Ngày tạo', 'đến ngày']}
                                    className="w-100"
                                    onChange={(value) => this.onChangeFilter('created_at', value)}
                                    defaultValue={[query.created_date_start ? moment(query.created_date_start, 'YYYY-MM-DD') : null, query.created_date_end ? moment(query.created_date_end, 'YYYY-MM-DD') : null]}
                                />,
                                <FilterableMultiTreeSelect
                                    options={service_active_list || []}
                                    placeholder="Dịch vụ"
                                    parameterName='service_id'
                                />,
                                <FilterableMultiSelect
                                    options={CustomerServiceStatus || []}
                                    placeholder="Trạng thái"
                                    parameterName='status'
                                    optionValue="value"
                                    optionLabel="label"
                                />,
                                <Select
                                    className="w-100"
                                    placeholder="Nguồn khách hàng"
                                    mode="multiple"
                                    allowClear
                                    showArrow
                                    showSearch
                                    value={this.state.selectedValues.length > 0 ? this.state.selectedValues : query.customer_source_id ? query.customer_source_id.split(',').map(Number) : []}
                                    onDeselect={(deselectedValue) => this.handleDeselect(deselectedValue)}
                                    onChange={(value) => this.onChangeFilter('customer_source_id', value)}
                                    defaultValue={query.customer_source_id ? query.customer_source_id.split(',').map(Number) : []}
                                    onSelect={(value) => this.setState({ selectedValues: [...this.state.selectedValues, value] })}
                                    filterOption={(input, option) =>
                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                    dropdownRender={menu => (
                                        <>
                                            {menu}
                                            <Divider style={{ margin: '8px 0' }} />
                                            <div style={{ padding: '2px 8px 8px 8px' }}>
                                                <Button className='w-100' type="dashed" onClick={this.handleSelectAll}>
                                                    Chọn tất cả
                                                </Button>
                                            </div>
                                        </>
                                    )}
                                >
                                    {customer_source_active_list.map(item => (
                                        <Option key={item.id} value={item.id}>{item.name}</Option>
                                    ))}
                                </Select>
                            ]
                        }
                    >
                        <BaseSelect
                            options={[
                                { value: 'CHOT', label: 'Dịch vụ đã chốt' },
                                { value: 'QUANTAM', label: 'Dịch vụ quan tâm' },
                            ]}
                            showSearch
                            placeholder="Loại dịch vụ"
                            className="table-button"
                            style={{ width: '200px' }}
                            onChange={(value) => this.onChangeFilter('type', value)}
                            defaultValue={query.type ? query.type : null}
                        />
                        <RangePicker
                            format="DD/MM/YYYY"
                            placeholder={['Ngày chốt', 'đến ngày']}
                            className="table-button"
                            style={{ width: '220px' }}
                            onChange={(value) => this.onChangeFilter('selected_at', value)}
                            defaultValue={[query.selected_date_start ? moment(query.selected_date_start, 'YYYY-MM-DD') : null, query.selected_date_end ? moment(query.selected_date_end, 'YYYY-MM-DD') : null]}
                        />
                        {
                            checkPermission('customer_services', 'export') ? (
                                <Button className="table-button" loading={isLoadingExport} type='default' onClick={() => this.do_export()} icon={<ExportOutlined />}>Export</Button>
                            ) : null
                        }
                        <Button className="table-button" type='primary' icon={<DownloadOutlined />} loading={loadingCapture} onClick={() => this.handleCaptureClick()}>Chụp màn hình</Button>
                        <Button className="table-button" icon={<ReloadOutlined />} loading={isLoading} onClick={() => this.reloadData()}>Refresh</Button>
                        {
                            hasSelected ? <span>Đang chọn {selectedRowKeys.length} bản ghi</span> : ''
                        }
                    </TableActionBar>
                </div>
                <Row gutter={16} className="mb-2" justify="space-between" style={{ margin: 0 }}>
                    <Card className="customer-services-list-statistic">
                        <StatisticNumber
                            title="Khách chốt"
                            value={statistical?.total_customer || 0}
                            precision={0}
                        />
                    </Card>
                    <Card className="customer-services-list-statistic">
                        <StatisticNumber
                            title="Dịch vụ chốt"
                            value={statistical?.total_completed_services || 0}
                            precision={0}
                        />
                    </Card>
                    <Card className="customer-services-list-statistic">
                        <StatisticNumber
                            title="Dịch vụ quan tâm"
                            value={statistical?.total_interest_services || 0}
                            precision={0}
                        />
                    </Card>
                    <Card className="customer-services-list-statistic">
                        <StatisticNumber
                            title="Giá gốc"
                            value={statistical?.total_regular_price || 0}
                            precision={0}
                            unit="đ"
                        />
                    </Card>
                    <Card className="customer-services-list-statistic">
                        <StatisticNumber
                            title="Giá bán"
                            value={statistical?.total_sale_price ?? 0}
                            precision={0}
                            unit="đ"
                        />
                    </Card>
                    <Card className="customer-services-list-statistic">
                        <StatisticNumber
                            title="Mức giảm giá"
                            value={statistical?.discount_rate || 0}
                            precision={0}
                            unit="đ"
                        />
                    </Card>
                    <Card className="customer-services-list-statistic">
                        <StatisticNumber
                            title="Thành tiền"
                            value={statistical?.total_amount || 0}
                            precision={0}
                            unit="đ"
                        />
                    </Card>
                </Row>
                <div className='has-custom-column-table-btn' ref={this.tableRef}>
                    <DynamicTable
                        rowKey="id"
                        ref={this.tableRef}
                        dataSource={services || []}
                        columns={columns}
                        isLoading={isLoading}
                        pagination={pagination}
                        moduleKey="customer_services"
                        rowSelection={false}
                        onChangeTable={(pagination, sorter) => this.onChangeTable(pagination, sorter)}
                    />
                </div>
                <CustomerServicesDetail
                    visible={isOpenDetail}
                    currentItem={currentData}
                    reloadData={() => this.onDetail(current_id)}
                    onCancel={() => this.toggleOpenDetail(false)}
                />
                <CustomerDetail
                    visible={isOpenCustomerDetail}
                    currentItem={currentCustomerData}
                    reloadData={() => this.onCustomerDetail(currentCustomerId)}
                    onCancel={() => this.toggleOpenCustomerDetail(false)}
                    loadingDetail={loadingDetail}
                />
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        services: state.CustomerServicesReducer.services,
        pagination: state.CustomerServicesReducer.pagination,
        service_active_list: state.ServiceReducer.service_active_list,
        customer_source_active_list: state.CustomerSourceReducer.customer_source_active_list,
        statistical: state.CustomerServicesReducer.statistical,
        branchActiveList: state.BranchReducer.branchActiveList,
        doctors: state.config.doctors,
        users: state.config.users
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getListServices: (filter) => dispatch(getListServices(filter)),
        getSpecificService: (id) => dispatch(getSpecificService(id)),
        getSpecificCustomer: (id) => dispatch(getSpecificCustomer(id)),
        getCustomerSourceActive: () => dispatch(getCustomerSourceActive()),
        getStatistical: filter => dispatch(getStatistical(filter)),
        exportExcel: (filter) => dispatch(exportExcel(filter)),
        getBranchActive: () => dispatch(getBranchActive()),
        getServiceActive: () => dispatch(getServiceActive())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'CustomerServicesList' })(CustomerServicesList));

